import { render } from "./MenuCard.vue?vue&type=template&id=2dc4d111&scoped=true"
import script from "./MenuCard.vue?vue&type=script&lang=js"
export * from "./MenuCard.vue?vue&type=script&lang=js"

import "./MenuCard.vue?vue&type=style&index=0&id=2dc4d111&scoped=true&lang=css"

import exportComponent from "/vercel/path0/my_res/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2dc4d111"]])

export default __exports__